export default [
    {
        path: '/interstate',
        name: 'Interstate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/interstate/InterstateIndex.vue'),
        },
    },
    {
        path: '/interstate/trip/:id/edit',
        name: 'InterstateTripEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
        },
        components: {
            default: () => import('@views/interstate/InterstateTripEdit.vue'),
        },
    },
    {
        path: '/interstate/lane/:id/edit',
        name: 'InterstateLaneEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
        },
        components: {
            default: () => import('@views/interstate/InterstateLaneEdit.vue'),
        },
    },
    {
        path: '/interstate/settings',
        name: 'InterstateSettings',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/interstate/InterstateSettings.vue'),
        },
    },
    {
        path: '/interstate/lane/create',
        name: 'InterstateLaneCreate',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
        },
        components: {
            default: () => import('@views/interstate/InterstateLaneCreate.vue'),
        },
    },
    {
        path: '/interstate/trip/create',
        name: 'InterstateTripCreate',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
        },
        components: {
            default: () => import('@views/interstate/InterstateTripCreate.vue'),
        },
    },
];
